import * as React from "react";
import last from "lodash/last";
import sortBy from "lodash/sortBy";
import { useTheme } from "styled-components";
import StringUtils from "util/StringUtils";
import { DEFAULT_HIGHLIGHT_COLOR } from "views/Constants";
import { isFunction } from "views/logic/aggregationbuilder/Series";
import { formatNumber } from "util/NumberFormatting";
import isNumeric from "../messagelist/IsNumeric";
const highlight = (value, idx, style = {}) => /* @__PURE__ */ React.createElement("span", { key: `highlight-${idx}`, style }, value);
function highlightCompleteValue(ranges, value) {
  if (ranges.length !== 1) {
    return false;
  }
  const { start, length } = ranges[0];
  const stringifiedValue = StringUtils.stringify(value);
  return start === 0 && length === stringifiedValue.length;
}
const shouldBeFormatted = (field, value) => isFunction(field) && isNumeric(value);
const PossiblyHighlight = ({ color = DEFAULT_HIGHLIGHT_COLOR, field, value, highlightRanges = {} }) => {
  const theme = useTheme();
  if (value === void 0 || value === null) {
    return "";
  }
  if (!highlightRanges || !highlightRanges[field]) {
    return shouldBeFormatted(field, value) ? formatNumber(value) : value;
  }
  const backgroundColor = color.colorFor(value);
  const style = {
    backgroundColor,
    color: theme.utils.contrastingColor(backgroundColor),
    padding: "0 1px"
  };
  if (highlightCompleteValue(highlightRanges[field], value)) {
    const formattedValue = shouldBeFormatted(field, value) ? formatNumber(value) : value;
    return highlight(formattedValue, 0, style);
  }
  const origValue = StringUtils.stringify(value);
  const ranges = sortBy(highlightRanges[field], (r) => r.start);
  const subst = (s, l) => origValue.substring(s, s + l);
  const rest = (pos) => origValue.substring(pos, origValue.length);
  const highlights = ranges.filter(({ start }) => start >= 0).filter(({ length }) => length >= 0).reduce(
    ([acc, i], cur, idx) => [
      [
        ...acc,
        subst(i, Math.max(0, cur.start - i)),
        // non-highlighted string before this range
        highlight(subst(Math.max(cur.start, i), Math.max(0, cur.length - Math.max(0, i - cur.start))), idx, style)
        // highlighted string in range
      ],
      cur.start + cur.length
    ],
    [[], 0]
  )[0];
  const lastRange = last(sortBy(ranges, (r) => r.start + r.length));
  highlights.push(rest(lastRange.start + lastRange.length));
  return /* @__PURE__ */ React.createElement("div", null, highlights);
};
export default PossiblyHighlight;
